import gql from 'graphql-tag';

export default gql`
  query TheaterDetails($id: ID, $slug: String) {
    theater(id: $id, slug: $slug) {
      id
      slug
      name
      address
      website
      city
      plan
      facebook
      country
      biography
      active
      director
      contact
      email
      telephone
      type
      favorite
      role
      images {
        url
        thumbUrl
      }
      features {
        name
        type
        value
      }
      productions {
        id
        slug
        name
        year
        type
        saleOrRent
        sets
        costumes
        titles
        props
        orchestration
        isDigital
        description
        images {
          url
          thumbUrl
        }
        features {
          type
          name
          value
          user {
            id
            name
          }
        }
        owner {
          id
          name
        }
        createdAt
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/TheaterDetails.js